import { adminActionTypes } from "src/action_types/section_action_types";

export function selectFacilityIdAction(facilityId) {
  return {
    type: adminActionTypes.selectRulesFacility,
    payload: facilityId
  };
}
